<form novalidate #currentForm="ngForm">
  <div class="test-container">
    <div class="section">
      <div class="test-name">
        <label>Test name *</label>
        <input
          class="name"
          type="text"
          name="name"
          [(ngModel)]="testName"
          (ngModelChange)="updateIdentity()"
          required
          #nameInput="ngModel"
          maxlength="80"
        />
        <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
          <mat-error *ngIf="nameInput.errors.maxlength">Name is too long</mat-error>
          <mat-error *ngIf="nameInput.errors.required">Name is required</mat-error>
        </div>
        <div>
          <mat-error *ngIf="isValidtestName()"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div class="error" *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
      <div class="comments">
        <label>Comments</label>
        <textarea
          type="text"
          name="comments"
          [(ngModel)]="comments"
          (ngModelChange)="updateIdentity()"
          rows="1"
          (focus)="rows = 2"
          (blur)="rows = 1"
          [rows]="rows"
          maxlength="150"
        >
        </textarea>
      </div>
    </div>
    <div class="column">
      <div *ngIf="showCustomerTechnician" class="row">
        <div class="section">
          <label>For customer/circuit</label>
          <input
            type="text"
            name="customer"
            [(ngModel)]="customer"
            (ngModelChange)="updateIdentity()"
            maxlength="30"
          />
        </div>
        <div class="section">
          <label>Contact</label>
          <input
            type="text"
            name="contact"
            [(ngModel)]="contact"
            (ngModelChange)="updateIdentity()"
            maxlength="30"
          />
        </div>
        <div class="section">
          <label>Email</label>
          <input
            type="text"
            name="email"
            [(ngModel)]="email"
            #emailInput="ngModel"
            (ngModelChange)="updateIdentity()"
            [pattern]="emailRegEx"
            maxlength="30"
          />
          <div class="error" *ngIf="emailInput.invalid && (emailInput.dirty || emailInput.touched)">
            <mat-error *ngIf="emailInput.errors.maxlength">Your email is too long</mat-error>
            <mat-error *ngIf="emailInput.errors.pattern">Email is invalid</mat-error>
          </div>
        </div>
        <div class="section">
          <label>Phone</label>
          <input
            type="text"
            name="phone"
            [(ngModel)]="phone"
            (ngModelChange)="updateIdentity()"
            maxlength="30"
          />
        </div>
      </div>
      <div *ngIf="showCustomerTechnician" class="row">
        <div class="section">
          <label>By technician</label>
          <input
            type="text"
            name="technician"
            [(ngModel)]="technician"
            (ngModelChange)="updateIdentity()"
            maxlength="30"
          />
        </div>
        <div class="section">
          <label>Techinican ID</label>
          <input
            type="text"
            name="technicianId"
            [(ngModel)]="technicianId"
            (ngModelChange)="updateIdentity()"
            maxlength="30"
          />
        </div>
      </div>
    </div>
  </div>
</form>
